import React, { FC, useState, useEffect } from "react";

// Services
import { DRFlowResolver } from "services/DRSolverService";
import { numPrettier } from "services/TextPrettierService";

// Interfaces
import { DRCalculatorOutput } from "types/DRInterface";

const LoanCalculatorOutputBox: FC<{
  loanAmount: number;
  loanDuration: number;
  getCalculatorOutputValues: any;
}> = (props) => {
  const [calculatorOutputValues, setCalculatorOutputValues] =
    useState<DRCalculatorOutput>({
      loanAmount: 0,
      interestRate: 0,
      monthlyPayment: 0,
      totalPayment: 0,
      APR: 0,
    });
  const [calculatorIsLoading, setCalculatorIsLoading] = useState(true);

  // ? Get repayment slider settings from DR
  const getCalculatorValues = () => {
    DRFlowResolver("7b9bbced-0fc6-2f8b-ca10-dd2fb403b5a1", {
      loanAmount: props.loanAmount,
      loanDuration: props.loanDuration,
    })
      .then((response) => {
        let responseData = response[0];
        setCalculatorOutputValues(responseData);
        props.getCalculatorOutputValues(responseData);
        if (Object.values(responseData).every((x) => x !== null && x !== "")) {
          setCalculatorIsLoading(false);
        }
      })
      .catch((Err) => {
        setCalculatorOutputValues({
          loanAmount: undefined,
          interestRate: undefined,
          monthlyPayment: undefined,
          totalPayment: undefined,
          APR: undefined,
        });
        console.error("DR Rule Flow call error: ", Err);
      });
  };

  // ?  Get output values for loan calculator from DR every 80ms on change
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getCalculatorValues();
    }, 80);

    return () => clearTimeout(delayDebounceFn);
  }, [props.loanAmount, props.loanDuration]);

  return (
    <>
      {calculatorIsLoading ? (
        <div className="loan-calculator__box loan-calculator__box-loader loan-calculator__output-box">
          <div>
            <div className="line line-40"></div>
            <div className="line line-60"></div>
          </div>
          <hr className="loan-calculator__divider"></hr>
          <div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
          <hr className="loan-calculator__divider"></hr>
          <div className="line"></div>
        </div>
      ) : (
        <div className="loan-calculator__box loan-calculator__output-box">
          <div>
            <p className="text text--primary fw--400">Monthly payment</p>
            <h3 className="heading heading--primary fw--700">
              {calculatorOutputValues.monthlyPayment
                ? "$" + numPrettier(calculatorOutputValues.monthlyPayment)
                : "--"}
            </h3>
          </div>
          <hr className="loan-calculator__divider"></hr>
          <div>
            <div className="output-section">
              <p className="text text--primary fw--400">Loan amount</p>
              <p className="text text--primary fw--600">
                {calculatorOutputValues.loanAmount
                  ? "$" + numPrettier(calculatorOutputValues.loanAmount)
                  : "--"}
              </p>
            </div>
            <div className="output-section">
              <p className="text text--primary fw--400">Interest rate</p>
              <p className="text text--primary fw--600">
                {calculatorOutputValues.interestRate
                  ? numPrettier(calculatorOutputValues.interestRate) + " %"
                  : "--"}
              </p>
            </div>
            <div className="output-section">
              <p className="text text--primary fw--400">APR</p>
              <p className="text text--primary fw--600">
                {calculatorOutputValues.APR
                  ? numPrettier(calculatorOutputValues.APR) + " %"
                  : "--"}
              </p>
            </div>
          </div>
          <hr className="loan-calculator__divider"></hr>
          <div className="output-section">
            <p className="text text--primary fw--500">Total repaid amount</p>
            <p className="text text--primary fw--700">
              {calculatorOutputValues.totalPayment
                ? "$" + numPrettier(calculatorOutputValues.totalPayment)
                : "--"}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default LoanCalculatorOutputBox;
